// extracted by mini-css-extract-plugin
module.exports = {"page":"CreditPage__page__JJDMW"};